import React from 'react';
import { Rating } from 'semantic-ui-react';
import './StarRating.css';
var defaultProps = {
  show: true,
  value: null,
  options: ['Terrible', 'Poor', 'Average', 'Very Good', 'Excellent']
};
export default function StarRating(_ref) {
  var show = _ref.show,
    options = _ref.options,
    onChange = _ref.onChange,
    value = _ref.value;
  var option = value ? options[value - 1] : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement("div", {
    className: "star-rating"
  }, /*#__PURE__*/React.createElement(Rating, {
    onRate: onChange,
    size: "large",
    icon: "star",
    maxRating: options.length
  }), option ? /*#__PURE__*/React.createElement("p", {
    className: "text-label"
  }, option) : /*#__PURE__*/React.createElement("p", {
    className: "text-label unselected"
  }, "Click to Rate")));
}
StarRating.defaultProps = defaultProps;